import React from "react";
import PropTypes from 'prop-types';
import { autoSlideDefaultInterval } from '../../../config/slider';
import Slide from './Slide';
import InfiniteSlider  from 'infinite-react-carousel';
import Placeholder from "../Placeholder";

let resizeTid = null;
let sliderTid = null;
let sliderSlidesToShow = 0;

const maxImageWidth = 1040;
const sideImagesWidthSum = 520;
const sliderRef = React.createRef();

const setSliderSlidesToShow = (sliderRef) => {
    if (sliderRef.current) {
        sliderSlidesToShow = sliderRef.current.innerSlider.props.slidesToShow;
    }
}

export default class Slider extends React.PureComponent {
    activeSlideIndex = 0;

    childNodes = [];
    state = {
        sliderSlidesToShow: 0,
        sliderHeight: 300,
        slides: this.props.slides,
        slideIndex: this.props.slideIndex,
        slidesCount: this.props.slides.length,
        isSliderRunning: false,
        isActiveImageLoaded: false,
        maxImageHeight: 0,
        maxImageHeightIndex: 0,
        mainImageHeight: 0,
        mainImage: null,
        slideNodes: [],
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
    };

    resizeHandler = (event) => {
        const { mainImage } = this.state;

        this.setState({
            mainImageHeight: 0,
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        });

        setSliderSlidesToShow(sliderRef);

        // code below needed to recalculate image height after page resize
        resizeTid = setTimeout(() => {
            if (!mainImage) {
                return false;
            }

            this.setState({
                mainImageHeight: mainImage.height,
            });
        });
    };

    static getDerivedStateFromProps(props, state) {
        setSliderSlidesToShow(sliderRef);

        return {
            ...state,
            slides: props.slides,
        };
    }
    componentDidMount() {
        window.addEventListener('resize', this.resizeHandler);

        setSliderSlidesToShow(sliderRef);
    }

    componentWillUnmount() {
        clearTimeout(resizeTid);

        window.removeEventListener('resize', this.resizeHandler);
    }

    getImageHeight = (image) => {
        return image.getBoundingClientRect().height;
    };

    startSlider = () => {
        clearInterval(sliderTid);

        sliderTid = setInterval(() => {
            this.slideNext();
        }, autoSlideDefaultInterval * 1000);
    };

    stopSlider = () => {
        clearInterval(sliderTid);
    };
    autoSlide = () => {
        if (this.isAutoSlide()) {
            this.startSlider();
        }
    };

    isAutoSlide = () => {
        return false;
        //return autoSlideInterval > 0;
    };

    onActiveImageLoad = (image) => {
        let { onLoad } = this.props;

        this.autoSlide();

        if (typeof onLoad === 'function') {
            onLoad();
        }

        this.setState({
            isActiveImageLoaded: true,
            mainImageHeight: 0,
            mainImage: image,
        });

        // this part is needed to set 'auto' height
        // for slider depending on images height
        // when images load from API
        setTimeout(() => {
            this.setState({
                mainImageHeight: image.height
            });
        });
    };
    onImageLoad = (image, index) => {
        let { maxImageHeight, maxImageHeightIndex } = this.state;

        let imageHeight = this.getImageHeight(image);

        if (imageHeight > maxImageHeight) {
            maxImageHeightIndex = index;
        }
        maxImageHeight = Math.max(imageHeight, maxImageHeight);

        this.setState({
            sliderHeight: maxImageHeight,
            maxImageHeight: maxImageHeight,
            maxImageHeightIndex: maxImageHeightIndex,
        });
    };
    slideNext = () => {
        let { slideIndex, slidesCount } = this.state;

        sliderRef.current.slickNext();

        let nextIndex = slideIndex + 1;
        if (nextIndex >= slidesCount) {
            nextIndex = 0;
        }

        this.setState({slideIndex: nextIndex});
    };
    slidePrev = () => {
        let { slideIndex, slidesCount } = this.state;

        sliderRef.current.slickPrev();

        let prevIndex = slideIndex - 1;
        if (prevIndex < 0) {
            prevIndex = slidesCount - 1;
        }

        this.setState({slideIndex: prevIndex});
    };
    slideClickHandler = (clickedIndex, currentSlideIndex) => {
        let { onCenterSlideClick } = this.props;

        if (typeof onCenterSlideClick === 'function') {
            onCenterSlideClick(clickedIndex);
        }

        if (this.isAutoSlide()) {
            this.stopSlider();
        }

        if (clickedIndex < currentSlideIndex) {
            return this.slidePrev();
        }

        return this.slideNext();
    };
    getSlideOffset = (index) => {
       let { slideIndex } = this.state;

        return index - slideIndex;
    };
    getCenterPadding = () => {
        let { windowWidth } = this.state;

        const designPadding = 260;
        const imageSideMargin = 30;

        if (windowWidth > (maxImageWidth + (designPadding * 2) + (imageSideMargin * 2))) {
            return (windowWidth - maxImageWidth - imageSideMargin) / 2;
        }
        // all numbers below are just magic paddings
        // to make the slider look fine for different
        // screen sizes
        if (windowWidth <= 500) {
            return 40;
        }
        if (windowWidth <= 600) {
            return 50;
        }
        if (windowWidth <= 750) {
            return 100;
        }
        if (windowWidth <= 1000) {
            return 200;
        }

        return designPadding;
    };
    getSlidesToShow = () => {
        let { windowWidth } = this.state;

        return 1;

        const displayedImageWidth = windowWidth - sideImagesWidthSum;

        if (displayedImageWidth <= maxImageWidth) {
            return 1;
        }

        let slidesToShow = Math.ceil(displayedImageWidth / maxImageWidth);

        if (slidesToShow === 1) {
            return slidesToShow;
        }

        if (slidesToShow % 3 !== 0) {
            slidesToShow++;
        }

        return slidesToShow;
    };
    render() {
        const {
            slideIndex,
            slides,
            isActiveImageLoaded,
            mainImageHeight,
        } = this.state;
        const {
            isHtml,
            dots,
            autoplaySpeed,
            isSlidesLoadAsync,
            isPacksFeaturedImagesPending,
            isFeaturedPacks,
            isPacksPending,
        } = this.props;
        const { innerWidth } = window;

        this.activeSlideIndex = slideIndex;

        if (isSlidesLoadAsync && (isPacksPending || !slides || slides.length === 0)) {
            return <Placeholder className={'placeholder-slider'}/>
        }

        if (isSlidesLoadAsync && !isFeaturedPacks) {
            return false;
        }

        const isStatic = sliderSlidesToShow >= slides.length;

        return (
            <InfiniteSlider
                ref={sliderRef}
                className={`slider${isStatic ? ' static' : ''}`}
                prevArrow={<div className={'prev-arrow'}></div>}
                nextArrow={<div className={'next-arrow'}></div>}
                slidesToShow={this.getSlidesToShow()}
                arrows={true}
                autoplay={false}
                initialSlide={!isStatic ? 1 : false}
                dots={dots ? true : false}
                appendDots={dots ? (dots) => <ul style={{ display: 'block' }}>
                    <div onClick={this.slidePrev} className={'slider-arrow left'}><img alt={'Prev'} src={require('../../../assets/images/slider/arrow-left.svg')}/></div>
                    {dots}
                    <div onClick={this.slideNext} className={'slider-arrow right'}><img alt={'Next'} src={require('../../../assets/images/slider/arrow-right.svg')}/></div>
                </ul> : null}
                centerMode={true}
                centerPadding={this.getCenterPadding()}
                autoplaySpeed={(autoplaySpeed ? autoplaySpeed : autoSlideDefaultInterval) * 1000}
                adaptiveHeight={!isHtml}
                pauseOnHover={true}
                >
                {slides.map((slide, index) => {
                    return <Slide
                        ref={(e) => {
                            if (!e) {
                                return false;
                            }
                            this.childNodes.push(e);
                        }}
                        mainImageHeight={mainImageHeight}
                        isHtml={isHtml}
                        slide={slide}
                        key={index}
                        index={index}
                        isPlaceholder={isSlidesLoadAsync && (!isActiveImageLoaded || isPacksFeaturedImagesPending)}
                        offset={this.getSlideOffset(index)}
                        onActiveImageLoad={this.onActiveImageLoad}
                        onImageLoad={this.onImageLoad}
                        currentSlideIndex={slideIndex}
                        onClick={() => {
                            this.slideClickHandler(index, slideIndex)
                        }}
                    />
                })}
            </InfiniteSlider>
        )
    }
}

Slider.propTypes = {
    onLoad: PropTypes.func,
    slides: PropTypes.array.isRequired,
    slideIndex: PropTypes.number.isRequired,
    autoplaySpeed: PropTypes.number,
    isHtml: PropTypes.bool,
    isPacksFeaturedImagesPending: PropTypes.bool,
    isFeaturedPacks: PropTypes.bool,
    isSlidesLoadAsync: PropTypes.bool,
    isPacksPending: PropTypes.bool,
    dots: PropTypes.bool,
    onCenterSlideClick: PropTypes.func,
};
